// eslint-disable-next-line import/prefer-default-export
export const INITIAL_MODAL_CONTENT = {
  title: '',
  description: '',
  videoImageAlt: '',
  videoCoverImage: '',
  youtubeVideo: '',
};
